export const levelDifferentiator = (skillPoint, isGangster) => {
  if (skillPoint >= 0 && skillPoint <= 49)
    return isGangster ? "Casino Worker" : "Junior";
  else if (skillPoint >= 50 && skillPoint <= 99)
    return isGangster ? "Moon Shiner" : "Constable";
  else if (skillPoint >= 100 && skillPoint <= 149)
    return isGangster ? "Smuggler" : "Sergeant";
  else if (skillPoint >= 150 && skillPoint <= 199)
    return isGangster ? "Body Guard" : "Inspector";
  else if (skillPoint >= 200 && skillPoint <= 249)
    return isGangster ? "Associate" : "Chief Inspector";
  else if (skillPoint >= 250 && skillPoint <= 299)
    return isGangster ? "Soldier" : "Superintendent";
  else if (skillPoint >= 300 && skillPoint <= 349)
    return isGangster ? "Captain" : "Chief Superintendent";
  else if (skillPoint >= 350 && skillPoint <= 399)
    return isGangster ? "Under Boss" : "Assistant Chief";
  else if (skillPoint >= 400 && skillPoint <= 449)
    return isGangster ? "Right-hand" : "Deputy Chief";
  else if (skillPoint >= 450)
    return isGangster ? "Mob Boss" : "Chief Constable";
};
